import { createStore } from 'vuex'
import { CourseResponse } from '@/types/course/response/CourseResponse'

export default createStore({
  state: {
    course: null as CourseResponse | null
  },
  mutations: {
    setCourse(state, newCourse: CourseResponse) {
      state.course = newCourse
    },
    // 添加清空课程的 mutation
    clearCourse(state) {
      state.course = null
    }
  },
  actions: {
    updateCourse({ commit }, newCourse: CourseResponse) {
      commit('setCourse', newCourse)
    },
    // 添加清空课程的 action
    resetCourse({ commit }) {
      commit('clearCourse')
    }
  },
  getters: {
    getCourse: (state) => state.course
  }
})

